import { render } from "./registerPage.vue?vue&type=template&id=16fe30f4&scoped=true"
import script from "./registerPage.vue?vue&type=script&lang=js"
export * from "./registerPage.vue?vue&type=script&lang=js"

import "./registerPage.vue?vue&type=style&index=0&id=16fe30f4&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fe30f4"]])

export default __exports__